package com.ives.utils;

import js.Browser;

class Capabilities {
	public static inline var CHROME:String = "Chrome";
	public static inline var FIREFOX:String = "Firefox";
	public static inline var SAFARI_DESKTOP:String = "Safari Desktop";
	public static inline var SAFARI_IOS:String = "Safari iOS";
	public static inline var EDGE:String = "Microsoft Edge";
	public static inline var IE:String = "Microsoft Internet Explorer";
	public static inline var UNSUPPORTED:String = "Unsupported";

	private static var mobileBrowsers:Array<String> = ["android", "ios", "ipad", "iphone"];

	private static var detectedBrowser:String = UNSUPPORTED;

    public static var supportedBrowser:Bool = false;

	private static var supportedBrowsers:Array<BrowserVersion> = [
		new BrowserVersion(CHROME, ["Chrome/([\\d\\.]+)(?!.*?Edge)"], [54, 0, 2830, 101]),
		new BrowserVersion(FIREFOX, ["Firefox/([\\d\\.]+)"], [48, 0]),
		new BrowserVersion(SAFARI_DESKTOP, ["OS X.*Version/([\\d\\.]+) Safari"], [9, 1, 2]),
		new BrowserVersion(SAFARI_IOS, ["(?:iphone|ipad).*Version/([\\d\\.]+).*Mobile.*Safari"], [9, 0, 0]),
		new BrowserVersion(EDGE, ["Edge/([\\d\\.]+)"], [13, 10000]),
		new BrowserVersion(IE, ["MSIE ([\\d\\.]+)", "Trident.*rv:([\\d\\.]+)"], [11, 0])
	];

	public static function is(browsers:Array<String>):Bool{
		for(browser in browsers)
			if(browser == detectedBrowser)
				return true;

		return false;
	}

	public static function isMobileBrowser():Bool{
		var userAgentString:String = Browser.navigator.userAgent.toLowerCase();

		for(browser in mobileBrowsers)
			if(userAgentString.indexOf(browser) != -1)
				return true;

		return false;
	}

	public static function isSupportedBrowser(){
		Log.debug('Using browser ${Browser.navigator.userAgent}');

		var passed:Bool = false;
		var browserName:String = Translator.getTransltaion("unknown.browser");
		var versionString:String = "";

		for(browser in supportedBrowsers){
			if(browser.matches(Browser.navigator.userAgent)){
				detectedBrowser = browserName = browser.name;
				versionString = versionToString(browser.version);

				Log.debug('Detected user using ${browserName} ${versionString}');

				if(browser.versionCheck()){
                    supportedBrowser = true;

					return;
                }
				else
					break;
			}
		}

		if(passed)
			return;

		var message:String = '${Translator.getTransltaion("minimal.browser")}:\n';

		for(browser in supportedBrowsers)
			message += '${browser.name} ${versionToString(browser.minimal)}\n';

		message += '\n${Translator.getTransltaion("using.browser")}:\n';
		message += '${browserName} ${versionString}\n\n';
		message += Browser.navigator.userAgent;

		Browser.alert(message);
	}

	private static function versionToString(version:Array<UInt>):String{
		return version.join(".");
	}
}
